import { SchematisationMeta } from "@nens/rana/api-v1";

import { FileDataTypeEnum } from "@/lib/rana-file-data-type";
import { ProjectFile } from "@/types/api-model-simple-names";

export function getSchematisationId(file: ProjectFile): number | undefined {
  if (file.dataType !== FileDataTypeEnum.Schematisation) return undefined;

  return (file.descriptor?.meta as SchematisationMeta | null | undefined)?.id;
}
